import App_ from './App';
import useApp from './useApp';
const App = App_;
App.useApp = useApp;
export default App;
